/**
 * Shared validation and conversion for facility cleaning standards.
 * Used by cleaningStandardsService mock and real.
 */

const convertTime24To12 = (time24) => {
  const [hour, min] = time24.split(':').map(Number);
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${hour12.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')} ${period}`;
};

const convertTime12To24 = (time12) => {
  const [time, period] = time12.split(' ');
  const [hour, min] = time.split(':').map(Number);
  let hour24 = hour;
  if (period === 'PM' && hour !== 12) hour24 = hour + 12;
  else if (period === 'AM' && hour === 12) hour24 = 0;
  return `${hour24.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
};

export const convertShiftsToAPIFormat = (shifts) => {
  if (!shifts || !Array.isArray(shifts)) return [];
  return shifts.map((shift) => ({
    name: shift.name,
    startTime: convertTime24To12(shift.startTime),
    endTime: convertTime24To12(shift.endTime),
  }));
};

const colors = ['#FFD700', '#FF8C00', '#4B0082', '#61b8e7', '#32CD32', '#FF1493'];

export const convertShiftsFromAPIFormat = (shifts) => {
  if (!shifts || !Array.isArray(shifts)) return [];
  return shifts.map((shift, index) => {
    const startTime24 = convertTime12To24(shift.startTime);
    const endTime24 = convertTime12To24(shift.endTime);
    const [startHour, startMin] = startTime24.split(':').map(Number);
    const [endHour, endMin] = endTime24.split(':').map(Number);
    let startMinutes = startHour * 60 + startMin;
    let endMinutes = endHour * 60 + endMin;
    if (endMinutes <= startMinutes) endMinutes += 24 * 60;
    const duration = (endMinutes - startMinutes) / 60;
    return {
      id: shift.id || `shift-${index + 1}`,
      name: shift.name,
      startTime: startTime24,
      endTime: endTime24,
      duration,
      color: colors[index % colors.length],
    };
  });
};

export const validateFacilityStandards = (standards) => {
  const validWaterChanges = ['frequent', 'standard', 'delayed'];
  const validSoilLoadLevels = ['super-heavy', 'heavy', 'medium', 'light', 'super-light'];
  if (
    standards.waterChanges != null &&
    standards.waterChanges !== '' &&
    !validWaterChanges.includes(standards.waterChanges)
  ) {
    throw new Error(`waterChanges must be one of: ${validWaterChanges.join(', ')}`);
  }
  if (
    standards.soilLoadLevel != null &&
    standards.soilLoadLevel !== '' &&
    !validSoilLoadLevels.includes(standards.soilLoadLevel)
  ) {
    throw new Error(`soilLoadLevel must be one of: ${validSoilLoadLevels.join(', ')}`);
  }
  if (standards.workShifts !== undefined && !Array.isArray(standards.workShifts)) {
    throw new Error('workShifts must be an array');
  }
};
